<template>
  <div class="page-container">
    <div class="toProject" @click="toProject"></div>
    <img src="../asset/img/1.jpg" alt="首页" class="full-image">
  </div>
</template>

<script>
export default {
  name: 'home',
  methods: {
    toProject() {
      this.$router.push('/product');
    }
  }
};
</script>

<style scoped lang="less">
.page-container {
  width: 100%;
  min-height: 100vh;
  cursor: pointer;
  position: relative;
}

.toProject {
  position: absolute;
top:10px;
left:515px;
width:60px;
height:30px;
}

.full-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>